export const WATCHLIST_TAB_VALUE = 'watchlist';

const STORAGE_KEY_PREFIX = 'market_collect_';

/** 读取本地旧数据，用于一次性迁移到服务端 */
export function getLegacyCollectList(userId) {
  if (!userId) return [];
  try {
    const raw = localStorage.getItem(`${STORAGE_KEY_PREFIX}${userId}`);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function clearLegacyCollectList(userId) {
  if (!userId) return;
  localStorage.removeItem(`${STORAGE_KEY_PREFIX}${userId}`);
}

export function isMarketCollected(collectList, marketId) {
  if (!marketId || !collectList || !collectList.length) return false;
  return collectList.some((item) => item.id === marketId);
}
